export const AutomatedTestingEnvironment = {
  dev: {
    env: "dev" as const,
    apiUrl: 'https://b2c.dev.bot-autoatencion.git.copec.cl/v1/automated-test/request-analysis',
    apiKey: 'gAUEebIG0o1PuQVZog9i556DDiwz0rxX90GN11Hw',
  },
  stg: {
    env: "stg" as const,
    apiUrl: 'https://b2c.stg.bot-autoatencion.git.copec.cl/v1/automated-test/request-analysis',
    apiKey: 'kFrCtYgEOg3bR5tOegQo51NHfXaAJRkh9MbVcNyQ',
  },
  prd: {
    env: "prd" as const,
    apiUrl: 'https://b2c.prd.bot-autoatencion.git.copec.cl/v1/automated-test/request-analysis',
    apiKey: 'bpXqRRkaI017Gu0LgKELK1UHxTuhpIW3hY741Kud',
  },

};